import PQueue from 'p-queue';

import { IPoolRawMeta } from 'modules/pool/types';

import { memoizePoolPromiseStorage, PoolMetaFetcher } from '../ipfsCache';
import {
  defaultOptions,
  FetchIPFSOptions,
  getPublicIPFSData,
} from './getPublicIPFSData';

const queue = new PQueue({
  concurrency: 1,
  interval: 300,
  intervalCap: 1,
  autoStart: true,
});

export async function loadPoolIPFSData(
  poolId: string,
  cid: string,
  withQueue = true,
): Promise<IPoolRawMeta> {
  // eslint-disable-next-line no-return-await
  async function getData<T>(
    cid: string,
    options: FetchIPFSOptions = defaultOptions,
  ): Promise<T> {
    return (await queue.add(() =>
      getPublicIPFSData<T>(cid, options),
    )) as Promise<T>;
  }

  return await memoizePoolPromiseStorage(
    poolId,
    cid,
    (withQueue ? getData : getPublicIPFSData) as PoolMetaFetcher,
  );
}
